"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookmarkIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BookmarkIcon = exports.BookmarkIcon = function BookmarkIcon(_ref) {
  var className = _ref.className,
    saved = _ref.saved,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#2F2F2F" : _ref$color;
  if (saved) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      className: className,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        clipPath: "url(#clip0_1671_20396)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M2.84893 23.55C3.39498 23.7834 3.99868 23.8467 4.58128 23.7319C5.16389 23.617 5.69834 23.3292 6.11493 22.906L11.9999 17.053L17.8849 22.906C18.1593 23.1844 18.4862 23.4056 18.8467 23.5568C19.2071 23.7081 19.594 23.7863 19.9849 23.787C20.3867 23.7858 20.7843 23.7053 21.1549 23.55C21.7054 23.3272 22.176 22.9436 22.5051 22.4493C22.8343 21.9549 23.0067 21.3728 22.9999 20.779V5C22.9983 3.67441 22.471 2.40356 21.5337 1.46622C20.5964 0.528882 19.3255 0.00158786 17.9999 0L5.99993 0C4.67434 0.00158786 3.40349 0.528882 2.46615 1.46622C1.52881 2.40356 1.00152 3.67441 0.99993 5V20.779C0.993477 21.3733 1.16651 21.9557 1.49639 22.4501C1.82628 22.9445 2.29767 23.3278 2.84893 23.55Z",
          fill: color
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
          id: "clip0_1671_20396",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white"
          })
        })
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    className: className,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      clipPath: "url(#clip0_1671_20397)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M20.1369 24C19.7669 23.999 19.4009 23.9247 19.0598 23.7813C18.7188 23.638 18.4095 23.4285 18.1499 23.165L11.9999 17.051L5.84988 23.169C5.45491 23.5697 4.94837 23.8422 4.3963 23.9508C3.84422 24.0594 3.27223 23.9992 2.75488 23.778C2.2324 23.5678 1.78543 23.205 1.47234 22.7369C1.15925 22.2688 0.994597 21.7171 0.999879 21.154V5C0.999879 3.67392 1.52666 2.40215 2.46435 1.46447C3.40203 0.526784 4.6738 0 5.99988 0L17.9999 0C18.6565 0 19.3067 0.129329 19.9133 0.380602C20.5199 0.631876 21.0711 1.00017 21.5354 1.46447C21.9997 1.92876 22.368 2.47996 22.6193 3.08658C22.8706 3.69321 22.9999 4.34339 22.9999 5V21.154C23.0055 21.7167 22.8414 22.268 22.5291 22.7361C22.2167 23.2041 21.7706 23.5672 21.2489 23.778C20.8967 23.9253 20.5186 24.0008 20.1369 24ZM5.99988 2C5.20423 2 4.44117 2.31607 3.87856 2.87868C3.31595 3.44129 2.99988 4.20435 2.99988 5V21.154C2.99952 21.3206 3.04855 21.4836 3.14078 21.6224C3.23301 21.7612 3.3643 21.8695 3.51807 21.9337C3.67184 21.9979 3.84119 22.0151 4.00472 21.9831C4.16825 21.9512 4.31864 21.8714 4.43688 21.754L11.2999 14.933C11.4872 14.7468 11.7407 14.6422 12.0049 14.6422C12.2691 14.6422 12.5225 14.7468 12.7099 14.933L19.5649 21.752C19.6831 21.8694 19.8335 21.9492 19.997 21.9811C20.1606 22.0131 20.3299 21.9959 20.4837 21.9317C20.6375 21.8675 20.7688 21.7592 20.861 21.6204C20.9532 21.4816 21.0022 21.3186 21.0019 21.152V5C21.0019 4.20435 20.6858 3.44129 20.1232 2.87868C19.5606 2.31607 18.7975 2 18.0019 2H5.99988Z",
        fill: color
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_1671_20397",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      })
    })]
  });
};